// extracted by mini-css-extract-plugin
export default {"root":"LinkShare_root__-9wjp","disabled":"LinkShare_disabled__E837Z","header":"LinkShare_header__Awrgj","title":"LinkShare_title__BVEEx","copy":"LinkShare_copy__tchR2"};